var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M17.65 7.17314C16.02 5.54314 13.71 4.60314 11.17 4.86314C7.50002 5.23314 4.48002 8.21314 4.07002 11.8831C3.52002 16.7331 7.27002 20.8231 12 20.8231C15.19 20.8231 17.93 18.9531 19.21 16.2631C19.53 15.5931 19.05 14.8231 18.31 14.8231C17.94 14.8231 17.59 15.0231 17.43 15.3531C16.3 17.7831 13.59 19.3231 10.63 18.6631C8.41002 18.1731 6.62002 16.3631 6.15002 14.1431C5.31002 10.2631 8.26002 6.82314 12 6.82314C13.66 6.82314 15.14 7.51314 16.22 8.60314L14.71 10.1131C14.08 10.7431 14.52 11.8231 15.41 11.8231H19C19.55 11.8231 20 11.3731 20 10.8231V7.23314C20 6.34314 18.92 5.89314 18.29 6.52314L17.65 7.17314Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.e41ade3b252e863fd526fb069bec6369.svg";
export { ForwardRef as ReactComponent };